import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { actions, selectors } from '../../../CollectionPanel/redux';
import {
  getIsDeviationInitialized,
  getTotalCountOfCollectedDeviations,
  getUserCollectionsCount,
  getUserCollectionsHasMore,
} from '../../../CollectionPanel/redux/selectors';
import { removeQueues } from '../../../Notifications/redux/actionCreators';
import { Props } from './AddToCollectionPopup';

export type StateProps = Pick<
  Props,
  | 'isInitialized'
  | 'hasMoreCollections'
  | 'selectedFolderIds'
  | 'collectionsCount'
  | 'totalCountOfPrivatelyCollectedDeviations'
>;
export type DispatchProps = Pick<
  Props,
  'initializeCollectionsForDeviation' | 'commitCollections' | 'removeQueues'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (
  state,
  { collectibleDeviation: { deviationId }, isPrivateCollections }
) => ({
  isInitialized: getIsDeviationInitialized(
    state,
    deviationId,
    isPrivateCollections
  ),
  collectionsCount: getUserCollectionsCount(
    state,
    deviationId,
    isPrivateCollections
  ),
  hasMoreCollections: getUserCollectionsHasMore(
    state,
    deviationId,
    isPrivateCollections
  ),
  selectedFolderIds: selectors.getSelectedFolderIds(
    state,
    deviationId,
    isPrivateCollections
  ),
  totalCountOfPrivatelyCollectedDeviations: isPrivateCollections
    ? getTotalCountOfCollectedDeviations(
        state,
        deviationId,
        isPrivateCollections
      )
    : undefined,
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  initializeCollectionsForDeviation: actions.initializeDeviation,
  commitCollections: actions.commitCollectionsCustom,
  removeQueues,
};

export default connect(mapStateToProps, mapDispatchToProps);
